import React, {Dispatch, SetStateAction, useCallback, useState} from "react";
import Modal from "../../Modal/Modal";
import Button from "../../buttons/Button";
import Portal from "../../Portal/Portal";
import {useTranslation} from "react-i18next";
import './delete-entity-modal.scss';
import classNames from "classnames";


type Props = {
    setModalShow: Dispatch<SetStateAction<boolean>>;
    deleteFn: () => Promise<void>;
    title?: string;
}

const DeleteConfirmationModal = ({setModalShow, deleteFn, title}: Props) => {
    const [blocked, setBlocked] = useState<boolean>(false);
    const {t} = useTranslation();

    const classes = classNames(
        "delete-confirmation-modal",
        blocked && 'disabled'
    )

    const cancelHandler = useCallback(() => {
        setModalShow?.(false);
    }, [setModalShow])

    const deleteHandler = useCallback(async () => {
        setBlocked(true);

        await deleteFn();
        setModalShow?.(false);

        setBlocked(false);
    }, [setModalShow, deleteFn])

    return (
        <Portal targetNodeId={"app"}>
            <Modal
                title={title ?? t('common.delete-confirmation')}
                setVisible={setModalShow}
                testId="deleteConfirmationModal"
            >
                <div className={classes}>
                    <Button
                        onClick={cancelHandler}
                        text={t("common.cancel")}
                        colorType="transparent"
                    />
                    <Button
                        type="submit"
                        onClick={deleteHandler}
                        text={t("common.delete")}
                        colorType="dark"
                        testId="deleteConfirmationModalDeleteBtn"
                    />
                </div>
            </Modal>
        </Portal>
    )
}

export default DeleteConfirmationModal;